export default function isUrl(value) {
  const reg = new RegExp(
    /^(?:(?:https?|ftp):\/\/)?(?:www\.)?[a-z0-9]+(?:[\\-\\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(?::[0-9]{1,5})?(?:\/.*)?$/i,
  );

  return reg.test(value);
}
